// Gallery Data - Photography Portfolio
// Minimal metadata: title and date only

const galleryData = [
  {
    id: 'summer-drive',
    title: 'summer drive',
    imageName: 'summer_drive',
    date: '2018'
  },
  {
    id: 'hello',
    title: 'hello',
    imageName: 'hello',
    date: '2019'
  },
  {
    id: 'pink-lips',
    title: 'pink lips',
    imageName: 'pink_lips',
    date: '2019'
  },
  {
    id: 'the-other-worlds',
    title: 'the other worlds',
    imageName: 'the_other_worlds',
    date: '2017'
  },
  {
    id: 'the-eyes-of-history',
    title: 'the eyes of history',
    imageName: 'the_eyes_of_history',
    date: '2017'
  },
  {
    id: 'dream',
    title: 'dream',
    imageName: 'dream',
    date: '2021'
  },
  {
    id: 'escape',
    title: 'escape',
    imageName: 'escape',
    date: '2022'
  },
  {
    id: 'lost-time',
    title: 'lost time',
    imageName: 'lost_time',
    date: '2020'
  },
  {
    id: 'spacefall',
    title: 'spacefall',
    imageName: 'spacefall',
    date: '2021'
  },
  {
    id: 'play',
    title: 'play',
    imageName: 'play',
    date: '2022'
  },
  {
    id: 'old-hello',
    title: 'old hello',
    imageName: 'old_hello',
    date: '2018'
  }
];

export default galleryData;
